import React from 'react';
import PropTypes from 'prop-types';
import { MAX_ATTACHMENTS_COUNT_PER_ITEM_FOR_CUSTOMER } from 'swag-client-common/utils/constants';
import DesignAttachmentsForm from './design-attachments-from';
import DesignAttachmentsItem from './design-attachments-item';
class DesignAttachments extends React.Component {
  render() {
    const {
      attachments,
      onFileAdd,
      onFileDelete
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, attachments.map(({
      originalFileName,
      name,
      src,
      key
    }, index) => /*#__PURE__*/React.createElement(DesignAttachmentsItem, {
      onFileDelete: () => onFileDelete(index, key),
      key: index,
      name: src ? originalFileName : name,
      src: src
    })), /*#__PURE__*/React.createElement(DesignAttachmentsForm, {
      onFileAdd: onFileAdd,
      isAttachmentPresent: !!attachments.length,
      isEnabled: attachments.length < MAX_ATTACHMENTS_COUNT_PER_ITEM_FOR_CUSTOMER
    }));
  }
}
// @ts-ignore
DesignAttachments.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.object),
  onFileAdd: PropTypes.func,
  onFileDelete: PropTypes.func
};
// @ts-ignore
DesignAttachments.defaultProps = {
  attachments: []
};
export default DesignAttachments;